// extracted by mini-css-extract-plugin
export default {"controls":"ControlPanel_controls__CX7Nm","controllerContainer":"ControlPanel_controllerContainer__tIG29","controllerLabel":"ControlPanel_controllerLabel__vHlzh"};